const APP = {
	name			: 'Квартэк :: Экраны для батарей',
	websiteWrapper	: $('#website-wrapper'),
	desktopXsWidth  : 1199,
	tabletWidth     : 991,
	tabletXsWidth   : 767,
	mobileWidth     : 599,
	mobileXsWidth   : 359,
	modalTrigger 	: $('.js-modal-trigger'),
	modalClose	 	: '.js-modal-close',
	modalClass 		: 'website-wrapper--modal-opened',
	inputTel	 	: $('.js-input-tel'),
	hiddenCarousel 	: 'carousel--hidden',
};